import React from 'react';

const FaxContext = React.createContext(null);

export const FaxProvider = FaxContext.Provider;

export default FaxContext;